// Translation exports
import { en } from './en';
import { es } from './es';
import { zh } from './zh';
import { de } from './de';
import { ja } from './ja';
import { ko } from './ko';
import { hi } from './hi';
import { ar } from './ar';
import { pt } from './pt';
import { ru } from './ru';
import { fr } from './fr';
import { tr } from './tr';
import { vi } from './vi';
import { id } from './id';
import { it } from './it';
import { bn } from './bn';
import { ms } from './ms';
import { th } from './th';
import { pl } from './pl';
import { fa } from './fa';
import { sv } from './sv';
import { nl } from './nl';
import { cs } from './cs';
import { hr } from './hr';

// Import other languages as they are created

export const translations = {
  en,
  es,
  zh,
  de,
  ja,
  ko,
  hi,
  ar,
  pt,
  ru,
  fr,
  tr,
  vi,
  id,
  it,
  bn,
  ms,
  th,
  pl,
  fa,
  sv,
  nl,
  cs,
  hr,
  // Add other languages here as they are created
} as const;

export type LanguageCode = keyof typeof translations;

// Helper function to get nested translation value
export function getNestedTranslation(obj: any, path: string): string {
  const keys = path.split('.');
  let current = obj;

  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return path; // Return the key if path not found
    }
  }

  return typeof current === 'string' ? current : path;
}
